import React, { useEffect, useState } from 'react'

const PrivacyTerms = () => {
    const [iframeHeight, setIframeHeight] = useState();
    useEffect(() => {
        const iframe_screen = document.querySelector("#privacy_terms");
        const handleLoad = () => {
            setIframeHeight(iframe_screen.contentDocument.body.scrollHeight + 20);
        };

        iframe_screen.addEventListener('load', handleLoad);

        // 클린업 함수
        return () => {
            iframe_screen.removeEventListener('load', handleLoad);
        };
    }, []);


    return (
        <div className="terms">
            <main>
                <section className="tpi">
                    <iframe
                        id="privacy_terms"
                        src={'/htmlTerms/privacyTerms.html'}
                        width="100%"
                        style={{backgroundColor: 'white'}}
                        height={iframeHeight}
                        title="개인정보 처리방침"
                    ></iframe>
                </section>
            </main>
        </div>
    );

};

export default PrivacyTerms;
